import React, { Component } from 'react'

import styles from './auth.module.css'
import brandLogo from '../../assets/images/brandIcon.svg'

import { Login } from '../../templates/login'
import { PasswordReset } from '../../templates/passwordReset'

export class Auth extends Component {

    state = {
        showLogin: true
    }

    setShowLogin = () => {
        this.setState(prevState => {
            return {
                showLogin: !prevState.showLogin
            }
        })
    }

    render() {
        return <div className={styles.container}>
            <a id={styles.brandLogo} href="http://onlive.poker/" ><img src={brandLogo} alt="Onlive Poker" /></a>
            <div className={styles.templates}>
                {this.state.showLogin
                    ? <Login toggleTemplate={this.setShowLogin} />
                    : <PasswordReset toggleTemplate={this.setShowLogin} />}
            </div>
        </div>
    }
}